import{createDescendantContext as e}from"./descendant/useDescendant.js";const[n,s,t,o]=e();export{n as MenuDescendantsProvider,o as useMenuDescendant,t as useMenuDescendants,s as useMenuDescendantsContext};
//# sourceMappingURL=useMenuDescendantsContext.js.map
